<!--
 * @Author: vince
 * @Date: 2021-08-16 09:32:29
 * @LastEditors: vince 273187189@qq.com
 * @LastEditTime: 2023-03-14 14:28:53
 * @Description:
-->
<template>
  <div class="teaching-design" v-loading="pageLoading">
    <el-form class="full-width" :model="filterFrom">
      <div class="filter-row pa-sm mb-sm">
        <div class="space"></div>

        <div class="mr-md">
          <el-input
            v-model="filterFrom.keyword"
            size="small"
            clearable
            placeholder="搜索教学设计名称"
            style="width: 250px"
            @input="refresh"
          >
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
        </div>
        <el-button
          v-if="power(userInfo.menuInfoList, 'teachingDesign-export')"
          type="primary"
          class="el-icon-upload2"
          size="small"
          @click="toExport"
          >导出</el-button
        >
        <el-button
          type="primary"
          icon="el-icon-plus"
          @click="onPub"
          size="small"
          >发布教学设计</el-button
        >
      </div>
      <!-- <el-form-item label="教材版本" class="filter-row mb-2px">
          <dicSelector
            dicType="textbook-version"
            controlType="checkbox"
            v-model="filterFrom.bookVsns"
            @change="refresh"
          ></dicSelector>
        </el-form-item> -->
      <el-form-item label="年级 / 册" class="filter-row mb-2px">
        <grade-term-selector
          controlType="checkbox"
          v-model="filterFrom.gradeAndTerms"
          @change="refresh"
        ></grade-term-selector>
      </el-form-item>
      <el-form-item label="学 科" class="filter-row mb-2px">
        <discipline
          controlType="checkbox"
          v-model="filterFrom.disciplineCodes"
          @change="refresh"
        ></discipline>
      </el-form-item>
    </el-form>
    <div class="list-box">
      <div class="column">
        <div class="tab-nav">
          <el-menu
            :default-active="filterFrom.sortBy"
            active-text-color="#409EFF"
            mode="horizontal"
            @select="(index) => refresh('sortBy', index)"
          >
            <el-menu-item index="1">最新</el-menu-item>
            <el-menu-item index="0">最热</el-menu-item>
            <el-menu-item index="2">收藏</el-menu-item>
          </el-menu>
        </div>
        <el-table
          :data="list"
          style="width: 100%; max-height: 100%; overflow-y: auto"
          @row-click="
            (row) =>
              $router.push({
                name: 'teachingDesignDetail',
                params: { id: row.id },
              })
          "
        >
          <el-table-column
            prop="title"
            label="标题"
            align="center"
          ></el-table-column>
          <el-table-column prop="otherAuthor" label="作者" align="center">
            <template slot-scope="scope">{{
              scope.row.otherAuthor | otherAuthorFil
            }}</template>
          </el-table-column>
          <el-table-column
            prop="createName"
            label="上传者"
            align="center"
          ></el-table-column>

          <el-table-column
            prop="browseCount"
            label="浏览"
            align="center"
            width="80"
          ></el-table-column>

          <el-table-column
            prop="downloadCount"
            label="下载"
            align="center"
            width="80"
          ></el-table-column>
          <el-table-column
            prop="collectCount"
            label="收藏"
            align="center"
            width="80"
          ></el-table-column>
          <el-table-column
            prop="createTime"
            label="发布日期"
            align="center"
          ></el-table-column>

          <pagination
            class="mb-md mr-md"
            slot="append"
            :pageObj="pageObj"
            @handleSizeChange="handleSizeChange"
            @handleCurrentChange="handleCurrentChange"
          ></pagination>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from "../../components/Pagination.vue";
import dicSelector from "../../components/school/dicSelector.vue";
import Discipline from "../../components/school/disciplineSelector.vue";
import GradeTermSelector from "../../components/school/grade&TermSelector.vue";
import { mapGetters, mapState } from "vuex";
import { postData, postJson } from "../../http/fetch";
import { power, fileSaveZip } from "@/utils/index.js";
export default {
  components: {
    dicSelector,
    Discipline,
    GradeTermSelector,
    Pagination,
  },
  data() {
    return {
      pageLoading: false,
      loading: false,
      noMore: false,
      filterFrom: {
        keyword: "",
        bookVsns: [],
        disciplineCodes: [],
        gradeAndTerms: [],
        sortBy: "0",
      },
      list: [],
      pageObj: {
        pageNum: 0,
        pageSize: 10,
        total: 0,
      },
    };
  },
  computed: {
    ...mapState(["userInfo"]),
    ...mapGetters(["schoolCodes", "operatorId"]),
    disabled() {
      return this.loading || this.noMore;
    },
  },
  mounted() {
    this.refresh("sortBy", 1);
  },
  methods: {
    toExport() {
      this.pageLoading = true;
      postJson("/teacherDesignInfoController/exportTeacherDesignInfo", {
        pageNum: this.pageObj.pageNum,
        pageSize: this.pageObj.pageSize,
        sortBy: this.filterFrom.sortBy,
        keyword: this.filterFrom.keyword,
        operatorId: this.operatorId,
        schoolCodes: this.schoolCodes,
        bookVsns: this.filterFrom.bookVsns.length
          ? this.filterFrom.bookVsns.map((m) => {
              return m.dicCode;
            })
          : null,
        disciplineCodes: this.filterFrom.disciplineCodes.length
          ? this.filterFrom.disciplineCodes.map((m) => {
              return m.disciplineCode;
            })
          : null,
        gradeAndTerms: this.filterFrom.gradeAndTerms.length
          ? this.filterFrom.gradeAndTerms.map((m) => {
              return {
                grade: m.grade,
                term: m.term,
              };
            })
          : null,
      })
        .then((data) => {
          fileSaveZip(data.url, data.name);
          this.pageLoading = false;
        })
        .catch(() => {
          this.pageLoading = false;
        });
    },
    power,
    onPub() {
      this.$router.push({
        name: "teachingDesignAdd",
      });
    },
    load() {
      this.pageObj.pageNum += 1;
      Number.parseFloat("12.23"); //解决ie Number.parseFloat报错
      this.getData();
    },
    getData() {
      this.loading = true;
      postJson("/teacherDesignInfoController/getTeacherDesignIfo", {
        pageNum: this.pageObj.pageNum,
        pageSize: this.pageObj.pageSize,
        sortBy: this.filterFrom.sortBy,
        keyword: this.filterFrom.keyword,
        operatorId: this.operatorId,
        schoolCodes: this.schoolCodes,
        bookVsns: this.filterFrom.bookVsns.length
          ? this.filterFrom.bookVsns.map((m) => {
              return m.dicCode;
            })
          : null,
        disciplineCodes: this.filterFrom.disciplineCodes.length
          ? this.filterFrom.disciplineCodes.map((m) => {
              return m.disciplineCode;
            })
          : null,
        gradeAndTerms: this.filterFrom.gradeAndTerms.length
          ? this.filterFrom.gradeAndTerms.map((m) => {
              return {
                grade: m.grade,
                term: m.term,
              };
            })
          : null,
      })
        .then((res) => {
          console.log("----res", res);
          if (res.records.length) {
            this.pageObj.total = res.total;
            this.pageObj.pageNum == 1;
            this.list = res.records;
            // : this.list.push(...res.records);
          } else {
            this.noMore = true;
          }
          if (this.pageObj.pageNum < res.pages) {
            this.pageObj.total = res.total;
            this.noMore = false;
          } else {
            this.noMore = true;
          }
        })
        .catch((e) => {})
        .finally(() => {
          this.loading = false;
        });
    },
    refresh(type, index) {
      if (type == "sortBy") {
        this.filterFrom.sortBy = index;
      }
      this.pageObj.pageNum = 1;
      this.list = [];
      this.getData();
    },
    //分页
    handleSizeChange(pageSize) {
      this.pageObj.pageNum = 1;
      this.pageObj.pageSize = pageSize;
      this.getData();
    },
    handleCurrentChange(curPage) {
      this.pageObj.pageNum = curPage;
      this.getData();
    },
  },
};
</script>

<style lang="less" scoped>
.teaching-design {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.article-main {
  flex: 1;
}
</style>

